import { analytics } from "./analytics";
import { announcements } from "./announcements";
import { gaps } from "./gaps";
import { inbox } from "./inbox";
import { bookings } from "./bookings";
import { leads } from "./leads";
import { routing } from "./routing";
import { workflows } from "./workflows";

/** Engage group: Inbox, Knowledge gaps, Leads, Announcements, Analytics + shared copy. */
export const engage = {
  time: {
    now: "now",
    minutes_one: "{{count}}m",
    minutes_other: "{{count}}m",
    hours_one: "{{count}}h",
    hours_other: "{{count}}h",
    yesterday: "Yesterday",
  },
  planGate: {
    title: "{{feature}} is not included in your plan",
    body: "Upgrade your plan to unlock this feature for your workspace.",
    bodyPlan: "{{feature}} is available on the {{plan}} plan and above. Upgrade to unlock it for your workspace.",
    upgrade: "See plans",
  },
  channels: {
    widget: "Widget",
    webapp: "Web app",
    mobile: "Mobile app",
    messenger: "Messenger",
    email: "Email",
    api: "API",
    playground: "Playground",
    slack: "Slack",
    teams: "Teams",
  },
  allAgents: "All agents",
  allChannels: "All channels",
  export: "Export",
  exportFailed: "The export couldn't be downloaded. Please try again.",
  noPermission: "You don't have permission to do this.",
  saveFailed: "That didn't save. Please try again.",
  loadMore: "Load more",
  inbox,
  gaps,
  leads,
  bookings,
  routing,
  announcements,
  analytics,
  workflows,
};
